import { useQuery } from '@tanstack/react-query';
import { mapEventReviewsResponse } from '../components/Events/mapEventReviews';
import { getEventReviews } from '../services/events';
import { eventReviewsQueryKeys } from './query-keys';

export const fetchEventReviews = async (eventId) => {
  const result = await getEventReviews(eventId);

  if (!result.success) {
    throw new Error(result.message || 'Failed to load event reviews');
  }

  return mapEventReviewsResponse(result.data);
};

export const useEventReviewsQuery = (eventId, options = {}) => {
  const { enabled = true, refetchOnWindowFocus = false } = options;

  return useQuery({
    queryKey: eventReviewsQueryKeys.list(eventId),
    enabled: Boolean(eventId) && enabled,
    refetchOnWindowFocus,
    queryFn: () => fetchEventReviews(eventId),
  });
};
